import { MenuItem } from "@mui/material";

interface Props {
    autoFocus?: boolean;
    close?: any;
    data?: any;
    tabIndex?: any;
    viewSelect?: any;
}

const ActiveActions = (props: Props) => {
    const viewUser = (event: any) => {
        props.close(event);
        props.viewSelect(props.data.id, props.data);
    };
    const editUser = (event: any) => {
        props.close(event);
        props.viewSelect(props.data.id, props.data, true);
    };

    return (
        <>
            <MenuItem onClick={viewUser}>View</MenuItem>
            <MenuItem onClick={editUser}>Edit</MenuItem>
        </>
    );
};

export default ActiveActions;
